import { type UseScrollZoomProps, useScrollZoom } from './hooks';

export default function ScrollZoom({
  startDate,
  pixelsPerDay,
  endDate,
  hideWeekends,
  setVisibleDates,
  visibleStartDate,
  visibleEndDate,
  scrollDistancePercent,
  render,
}: UseScrollZoomProps & { render: any }) {
  const zoomRef = useScrollZoom({
    startDate,
    pixelsPerDay,
    endDate,
    hideWeekends,
    setVisibleDates,
    visibleStartDate,
    visibleEndDate,
    scrollDistancePercent,
  });

  return render({ zoomRef });
}
